import BaseDialog from '~HIOR/components/dialog/Dialog'
import { Dialog, Notify } from 'quasar'
import { isMobile } from './propsMixin'

export const confirm = async (options = {}) => {
  const {
    title = 'Confirm',
    messages = [],
    persistent = false,
    okLabel = 'Ok',
    cancelLabel = 'Annuleren',
    hideCancelButton = false,
  } = options

  return new Promise((resolve) => {
    Dialog.create({
      component: BaseDialog,
      componentProps: {
        title,
        messages,
        persistent,
        hideCancelButton,
        cancel: {
          label: cancelLabel,
        },
        ok: {
          label: okLabel,
        },
      },
    }).onOk(() => {
      resolve(true)
    }).onCancel(() => {
      resolve(false)
    })
  })
}
export const prompt = async (options = {}) => {
  const {
    title = 'Prompt',
    message = '?',
    label = '',
    cancel = true,
    persistent = false,
  } = options
  return new Promise((resolve) => {
    Dialog.create({
      title,
      message,
      prompt: {
        model: '',
        label,
      },
      cancel: cancel ? 'Annuleren' : false,
      persistent,
    }).onOk(data => {
      resolve(data)
    }).onCancel(() => {
      resolve(null)
    })
  })
}
export const toast = (type, message) => {
  Notify.create({
    message,
    color: type === 'error' ? 'error' : 'success',
    position: isMobile ? 'top' : 'bottom',
    attrs: { role: 'alert' },
  })
}

export default {
  methods: {
    $confirm: confirm,
    $prompt: prompt,
    $toast: toast,
  }
  ,
}
